<template>
    <div class="message-box">
        <div class="right-box" id="searchBar">
            <i class="el-icon-headset"></i>
            <div class="box-title" ref="buttonBoxSelf" @click="getDialog">留言咨询</div>
        </div>
        <el-dialog  :width="dialogfromWidth.width" @close="handleClose" style="text-align:center;" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
            <div class="dialog-title">填写留言咨询</div>
            <el-form :model="form" ref="ruleForm" :label-width="dialogfromWidth.formLabelWidth" :rules="rulesForm" label-position="right" class="dialog-form">
                <el-form-item label="公司名称:"  prop="compName">
                    <el-input class="handle-input" v-model="form.compName" maxlength="20" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="联系人:"  prop="name">
                    <el-input class="handle-input" v-model="form.name" maxlength="20" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="联系方式:" prop="phone">
                    <el-input class="handle-input" v-model="form.phone" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="留言内容:" prop="message">
                    <el-input class="handle-input" v-model="form.message" type="textarea" :rows="4" maxlength="50" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item >
                    <div class="handle-button"  @click="getSubmit('ruleForm')">立即提交</div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {SubmitMessage} from '@/api/index'
export default {
    data() {
        return {
            dialogFormVisible:false,
            form:{
                compName:"",
                name:"",
                phone:"",
                message:"",
            },
            rulesForm:{
                compName:[{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                name:[{ required: true, message: '请输入联系人', trigger: 'blur' }],
                phone:[{ required: true, message: '请输入联系方式', trigger: 'blur' },{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的联系方式' }],
                message:[{ required: true, message: '请输入留言内容', trigger: 'blur' }],
            },
            dialogfromWidth:{
                width:'650px',
                formLabelWidth:'100px',
            },
        };
    },
    created(){
		if(document.body.clientWidth <= 1920){
			this.dialogfromWidth.width = '650px';
			this.dialogfromWidth.formLabelWidth = '100px';
		}else if(document.body.clientWidth > 1920){
			this.dialogfromWidth.width = '1300px';
			this.dialogfromWidth.formLabelWidth = '200px';
		}
	},

    methods: {
        handleClose(){
            this.form.compName = "";
            this.form.name = "";
            this.form.phone = "";
            this.form.message = "";
        },
        getDialog(){
            this.dialogFormVisible = true;
        },
        getSubmit(){
            // if(!this.form.compName){
            //     this.$message.error('请输入公司名称');
            //     return;
            // }
            // if(!this.form.name){
            //     this.$message.error('请输入联系人');
            //     return;
            // }
            // if(!this.form.phone){
            //     this.$message.error('请输入联系方式');
            //     return;
            // }
            var reg = /^1[3-9]\d{9}$/;
			if(!reg.test(this.form.phone)){
				this.$message.error('请输入正确的联系方式');
				return;
			}
            // if(!this.form.message){
            //     this.$message.error('请输入留言内容');
            //     return;
            // }
            let data = {
				companyName:this.form.compName,
				linkName:this.form.name,
				linkPhone:this.form.phone,
				messages:this.form.message,
			}
			SubmitMessage(data).then(res=>{
				if(res.success){
					this.$message.success('提交成功！');
                    this.dialogFormVisible = false;
					this.form.compName = "";
					this.form.name = "";
					this.form.phone = "";
					this.form.message = "";
				}else {
					this.$message.error('提交失败')
				}
			})
        }
    },
};
</script>

<style lang="less" scoped>
.right-box{
    position:absolute;
    right:10px;
    top:30%;
    z-index:999;
    padding:10px 10px;
    width:auto;
    height:auto;
    text-align: center;
    font-size:18px;
    // color:#fff;
    background-color:#F8BC2B;
    transition: all 2.5s;
    .box-title{
        // z-index:99;
        writing-mode: vertical-rl;
        cursor: pointer;
    }
}
.dialog-title{
    width:500px;
    height:auto;
    margin:0 auto;
    text-align: center;
    line-height:50px;
    font-size:20px;
    font-weight:bold;
    color:#000;
    // background-color: #f00;
}
.dialog-form{
    width:500px;
    margin:0 auto;
}
.handle-input{
    width:400px;
    border-radius: 20px;
}
.handle-button{
    width:500px;
    border-radius: 30px;
    color:#F1DBD8;
    height:40px;
    font-size:14px;
    letter-spacing: 5px;
    line-height:40px;
    margin-left:-100px;
    background-color:#B11E0F;
    cursor:pointer;

}
.handle-button:hover{
    color:#F1DBD8;
    background-color:#B11E0F;
}
</style>